import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { withPromisedComponent } from "@components/dialog/withPromisedComponent";
import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IEntity } from "@odata/BindingContext";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

import { withDomManipulator } from "../../../../contexts/domManipulator/withDomManipulator";
import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { withAccruals } from "../../extensions/accruals/withAccruals";
import { withTimeResolution } from "../../extensions/timeResolution/withTimeResolution";
import IssuedDocumentBaseFormView from "../../IssuedDocumentBaseFormView";
import {
    handleClearOriginalDocumentSwitchChange,
    onAfterCorrectiveInvoiceCorrectedDocumentLoad,
    onAfterCorrectiveInvoiceInitialLoad,
    onBeforeCorrectiveFormSave
} from "../CommonCorrectiveSharedUtils";


class CorrectiveInvoicesIssuedFormView extends IssuedDocumentBaseFormView {
    documentTypeCode = DocumentTypeCode.CorrectiveInvoiceIssued;

    async onAfterLoad(hasPreloadedData?: boolean): Promise<void> {
        await super.onAfterLoad(hasPreloadedData);
        const { storage } = this.props;

        if (!hasPreloadedData) {
            onAfterCorrectiveInvoiceInitialLoad(storage);
        } else {
            onAfterCorrectiveInvoiceCorrectedDocumentLoad(storage, this.refreshCurrencyExchangeRateAfterDateChange);
        }
        storage.setBusy(false);
    }

    documentSpecificChangeHandlers(e: ISmartFieldChange): void {
        super.documentSpecificChangeHandlers(e);

        handleClearOriginalDocumentSwitchChange(e, this.props.storage);
    }

    onBeforeSave = (): IEntity => {
        return onBeforeCorrectiveFormSave(this.props.storage);
    };
}

export default withPromisedComponent(withConfirmationDialog(withTimeResolution(withAccruals({ isExpense: false })(withPermissionContext(withDomManipulator(CorrectiveInvoicesIssuedFormView))))));